import { z } from 'zod';

export default z.object({
  urlBase: z.string().url(),
  trackerUrl: z.string().url(),
  siteId: z.number(),
  configurations: z.object({
    disableCookies: z.boolean()
  })
});
